import { Box, makeStyles } from '@material-ui/core';
import Text from '../../../../components/Text';
import { CheckIcon } from '../../../../components/Icon';
import { initValue } from '../../../../utils';
import redirectIcon from '../../../../static/images/redirectIcon.png';

const statusColor = {
  Pending: '#FA8A82',
  'In Progress': '#FECA06',
  Hold: '#A6B0C3',
  Withdrawn: '#767576',
  Completed: '#34C759',
};

const useStyles = makeStyles((theme) => ({
  status: ({ status, inProgressWithWardReady }) => ({
    borderRadius: '4px',
    backgroundColor: inProgressWithWardReady ? '#F4FF72' : statusColor[status],
    padding: '0.625rem 0.9375rem',
    display: 'flex',
    fontSize: '1rem',
    color: inProgressWithWardReady ? '#333333' : '#FFF',
    fontFamily: 'NotoSans-Medium',
  }),
  checkIcon: {
    color: '#7D86A9',
    fontSize: '1rem',
    marginRight: '0.5rem',
  },
}));

const StatusUI = ({ status, name, showRedirectIcon = false, nameSize = '0.875rem' }) => {
  const inProgressWithWardReady = status === 'In Progress' && name === 'Ward Ready';
  const classes = useStyles({ status, inProgressWithWardReady });

  return (
    <Box display="inline-flex" alignItems="flex-start" flexDirection="column" gridGap="0.32rem">
      <Box display="flex" alignItems="center" gridGap="0.5rem">
        <div className={classes.status}>{initValue(status, '')}</div>
        {showRedirectIcon && (
          <Box style={{ width: 23, height: 23 }}>
            <img width="100%" height="100%" src={redirectIcon} alt="redirect icon" />
          </Box>
        )}
      </Box>
      {name && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CheckIcon className={classes.checkIcon} />
          <Text fontSize={nameSize}>{initValue(name, '')}</Text>
        </Box>
      )}
    </Box>
  );
};

export default StatusUI;
